<template>
  <div class="party-entry" :class="{ 'has-bg': !!pageBgUrl }">
    <div v-if="pageBgUrl" class="party-entry__bg" :style="{ backgroundImage: 'url(' + pageBgUrl + ')' }" />
    <div class="party-entry__body">
      <div v-if="loading" class="pe-state">
        <van-loading size="22px" vertical color="#94a3b8">加载中...</van-loading>
      </div>
      <div v-else-if="errorMsg" class="pe-state pe-state--err">{{ errorMsg }}</div>

      <div v-else-if="!joined" class="pe-gate">
        <h1 class="pe-gate__title">{{ activityTitle }}</h1>
        <p class="pe-gate__sub">参与互动活动需先授权昵称、手机号</p>
        <van-button block type="primary" class="pe-gate__btn" @click="openAuth">授权进入活动</van-button>
        <p class="pe-gate__tip">未授权将无法参与抽奖、互动等环节</p>
      </div>

      <div v-else class="pe-main">
        <div class="pe-hud">
          <span class="pe-hud__scene">{{ sceneLabel }}</span>
          <span class="pe-hud__phase" :class="'is-' + phaseClass"><i class="pe-hud__dot" />{{ phaseLabel }}</span>
        </div>

        <div v-if="isPhotoLottery" class="pe-photo">
          <h2 class="pe-photo__title">{{ myPhotoUrl ? '照片已上传' : '上传照片参与抽奖' }}</h2>
          <div class="pe-photo__frame" :class="{ 'is-uploading': photoUploading }" @click="choosePhoto">
            <img v-if="myPhotoUrl" :src="myPhotoUrl" alt="">
            <div v-else class="pe-photo__empty">
              <span>请上传参与</span>
            </div>
            <span v-if="photoUploading" class="pe-photo__mask">上传中…</span>
          </div>
          <input ref="photoInput" class="pe-photo__file" type="file" accept="image/*" @change="onPhotoChange">
          <p class="pe-photo__tip">已入场 {{ joinedCount }} 人 · 已上传 {{ photoCount }} 张</p>
        </div>

        <div v-else-if="miniView === 'tap-game'" class="pe-card pe-tap">
          <div class="pe-card__title">{{ miniTitle }}</div>
          <div class="pe-card__sub">{{ canPlay ? '快速点击下方按钮，分数实时同步大屏' : '等待大屏开始' }}</div>
          <div class="pe-stats">
            <div class="pe-stat"><span>我的分数</span><strong>{{ snap.myScore || 0 }}</strong></div>
            <div class="pe-stat"><span>我的排名</span><strong>{{ snap.myRank || 0 }}</strong></div>
          </div>
          <button
            class="pe-tap__btn"
            :disabled="!canPlay"
            @click="onTap"
          >{{ snap.phase === 'COUNTDOWN' ? countdownLeft + 's' : '快速点击' }}</button>
        </div>

        <div v-else-if="miniView === 'lottery-wait'" class="pe-card pe-wait">
          <div class="pe-card__title">{{ lotteryTitle }}</div>
          <div class="pe-lottery" :class="'is-' + lotteryStatus">
            <i class="pe-lottery__dot" />
            {{ lotteryStatusText }}
          </div>
          <div class="pe-stats">
            <div class="pe-stat"><span>已入场</span><strong>{{ joinedCount }}</strong></div>
            <div class="pe-stat"><span>本轮中奖</span><strong>{{ lotteryWinnerCount }}</strong></div>
          </div>
          <p class="pe-card__tip">请留意大屏，中奖名单会实时公布</p>
        </div>

        <div v-else-if="miniView === 'message-mini'" class="pe-card pe-message">
          <div class="pe-card__title">{{ miniTitle }}</div>
          <div class="pe-stats">
            <div class="pe-stat"><span>消息</span><strong>{{ messageCount }}</strong></div>
            <div class="pe-stat"><span>点赞</span><strong>{{ gameData.likes || 0 }}</strong></div>
          </div>
          <van-field v-model="messageText" :maxlength="messageMaxLen" placeholder="说点什么..." class="pe-message__input" />
          <div class="pe-message__actions">
            <van-button type="primary" block :disabled="!canPlay" @click="onSendMessage">发送上墙</van-button>
            <van-button plain type="primary" class="pe-like-btn" :disabled="!canPlay" @click="onLike">点赞</van-button>
          </div>
          <p class="pe-card__tip">{{ canPlay ? '内容将实时展示在大屏' : '等待大屏开始互动' }}</p>
        </div>

        <div v-else-if="miniView === 'vote-mini'" class="pe-card pe-vote">
          <div class="pe-card__title">{{ miniTitle }}</div>
          <div class="pe-card__sub">共 {{ voteTotal }} 票 · 一人一票</div>
          <div class="pe-vote__list">
            <div
              v-for="opt in voteOptions"
              :key="opt"
              class="pe-vote__item"
              :class="{ active: myVote === opt, disabled: !canPlay }"
              @click="onVote(opt)"
            >
              <div class="pe-vote__head">
                <span class="pe-vote__name">{{ opt }}</span>
                <span class="pe-vote__rate">{{ votePercent(opt) }}%</span>
              </div>
              <div class="pe-vote__bar">
                <div class="pe-vote__fill" :style="{ width: votePercent(opt) + '%' }" />
              </div>
              <div class="pe-vote__foot">
                <span>{{ voteCount(opt) }} 票</span>
                <span v-if="myVote === opt" class="pe-vote__mine">已投</span>
              </div>
            </div>
          </div>
          <p class="pe-card__tip">{{ canPlay ? '点击选项即可投票' : '等待大屏开始投票' }}</p>
        </div>

        <div v-else-if="miniView === 'grab-mini'" class="pe-card pe-grab">
          <div class="pe-grab__card">
            <div class="pe-grab__label">{{ miniTitle }}</div>
            <div class="pe-grab__amount">¥{{ Number(gameData.myAmount || 0).toFixed(2) }}</div>
            <div class="pe-grab__meta">剩余 {{ remainCount }} 个 · 已抢 {{ grabbedCount }} 人</div>
            <button class="pe-grab__btn" :disabled="!canPlay || grabBusy" @click="onGrab">{{ canPlay ? (grabBusy ? '抢购中…' : '抢红包') : '等待开始' }}</button>
          </div>
          <p class="pe-card__tip">抢到的红包会在大屏滚动展示</p>
        </div>

        <div v-else class="pe-card pe-wait">
          <div class="pe-card__title">{{ miniTitle }}</div>
          <div class="pe-stats">
            <div class="pe-stat"><span>已入场</span><strong>{{ joinedCount }}</strong></div>
          </div>
          <p class="pe-card__tip">等待大屏进入下一个环节</p>
        </div>
      </div>
    </div>

    <!-- 仿微信官方授权弹层：底部弹出，未授权不能参与 -->
    <van-popup
      v-model="authVisible"
      position="bottom"
      round
      :close-on-click-overlay="false"
      :safe-area-inset-bottom="true"
      class="wx-auth-popup"
    >
      <div class="wx-auth">
        <div class="wx-auth__avatar-head">
          <div class="wx-auth__avatar-wrap">
            <div class="wx-auth__avatar-big" @click="chooseAvatar">
              <img :src="authAvatarPreview" alt="">
              <span v-if="avatarUploading" class="wx-auth__avatar-loading">上传中…</span>
            </div>
            <span class="wx-auth__opt-tag">可选</span>
          </div>
          <input ref="avatarInput" class="wx-auth__file" type="file" accept="image/*" @change="onAvatarChange">
        </div>

        <div class="wx-auth__list">
          <div class="wx-auth__item">
            <label class="wx-auth__label"><em class="wx-auth__req">*</em>昵称</label>
            <input v-model="nickName" class="wx-auth__input" maxlength="12" placeholder="请输入昵称">
          </div>
          <div class="wx-auth__item">
            <label class="wx-auth__label"><em class="wx-auth__req">*</em>手机号</label>
            <input v-model="phone" class="wx-auth__input" type="tel" maxlength="11" placeholder="请输入11位手机号">
          </div>
        </div>

        <p class="wx-auth__tip">授权后才能参与活动，未授权无法进入</p>

        <div class="wx-auth__actions">
          <button type="button" class="wx-auth__btn wx-auth__btn--deny" @click="onAuthDeny">拒绝</button>
          <button type="button" class="wx-auth__btn wx-auth__btn--allow" :disabled="joining" @click="onAuthAllow">
            {{ joining ? '授权中…' : '允许' }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { h5AnonymousSilentLogin } from '@/api/api'
import { partyEvent, partyJoin, partyScoreReport, partyScreenBootstrap, partySnapshot, partyUploadImage, partyUploadPhoto } from '@/api/party'
import { ensureSignstoreH5Uid } from '@/utils/signstore-h5-uid'
import { ensureSignstoreAnonymousLoggedIn, mergeActivityEntryQuery, pickH5LinkSignParamsFromQuery } from '@/utils/signstore-h5-auth'
import { getImageUrl } from '@/utils/image'
import { resolveImageAssetUrl } from '@/utils/uploadBase'
import { PARTY_DEFAULT_AVATAR } from './partyAssets'
import { resolveH5StageKind } from './registry'
import {
  initPartyTrack,
  disposePartyTrack,
  setPartyTrackContext,
  trackPartyEnter,
  trackPartyInteract,
  trackPartyJoin,
  trackPartyGameEnd,
  trackPartyGameStart,
  trackPartyPageLeave,
  trackPartyPageView,
  trackPartyScore,
  trackPartyUiClick,
  trackPartyMiniView
} from '@/utils/party-track'

export default {
  name: 'PartyEntry',
  data() {
    return {
      loading: true,
      errorMsg: '',
      activityCode: '',
      storeCode: '',
      signParams: null,
      h5Uid: '',
      activityTitle: '年会互动',
      joined: false,
      joining: false,
      nickName: '',
      phone: '',
      avatarUrl: '',
      avatarUploading: false,
      photoUrl: '',
      photoUploading: false,
      authVisible: false,
      pendingDelta: 0,
      messageText: '',
      myVoteLocal: '',
      grabBusy: false,
      snap: {
        miniSceneKey: 'home',
        phase: 'IDLE',
        onlineCount: 0,
        participantCount: 0,
        myScore: 0,
        myRank: 0,
        lotteryDraft: null,
        partyConfig: {},
        gameData: {},
        photos: [],
        myPhoto: '',
        countdownEndAt: 0,
        roundId: ''
      },
      pollTimer: null,
      reportTimer: null,
      tickTimer: null,
      lastRev: 0,
      now: Date.now(),
      polling: false,
      lastPhase: 'IDLE',
      lastView: '',
      pageStartedAt: Date.now()
    }
  },
  computed: {
    scenes() {
      return (this.snap.partyConfig && this.snap.partyConfig.scenes) || []
    },
    currentScene() {
      return this.scenes.find(s => s.sceneKey === this.snap.miniSceneKey) || null
    },
    sceneLabel() {
      return (this.currentScene && this.currentScene.label) || this.snap.miniSceneKey || this.activityTitle
    },
    phaseLabel() {
      const map = {
        IDLE: '待机',
        WARMUP: '预热',
        COUNTDOWN: '倒计时',
        RUNNING: '进行中',
        LOTTERY: '抽奖中',
        SETTLED: '结算'
      }
      return map[this.snap.phase] || this.snap.phase
    },
    phaseClass() {
      return String(this.snap.phase || 'IDLE').toLowerCase()
    },
    miniGame() {
      const kind = resolveH5StageKind({
        sceneKey: this.snap.miniSceneKey,
        scene: this.currentScene,
        phase: this.snap.phase,
        partyConfig: this.snap.partyConfig
      })
      const map = {
        lottery: 'lottery-wait',
        lottery_variant: 'lottery-wait',
        photo_lottery: 'photo-mini',
        rolling_avatar: 'lottery-wait',
        open_box: 'lottery-wait',
        score: 'tap-game',
        message: 'message-mini',
        vote: 'vote-mini',
        red_packet: 'grab-mini'
      }
      return { view: map[kind] || 'wait' }
    },
    /** 当前环节是否为照片抽奖（决定 C 端是否展示居中上传照片） */
    isPhotoLottery() {
      return this.miniGame.view === 'photo-mini'
    },
    myPhotoUrl() {
      return this.photoUrl || this.snap.myPhoto || ''
    },
    miniView() {
      return this.miniGame.view
    },
    miniTitle() {
      return (this.currentScene && this.currentScene.label) || this.activityTitle
    },
    gameData() {
      return this.snap.gameData || {}
    },
    photoCount() {
      return (this.snap.photos || []).length
    },
    lotteryStatus() {
      const st = String((this.snap.lotteryDraft && this.snap.lotteryDraft.status) || '')
      if (st === 'confirmed') return 'reveal'
      if (st === 'pending') return 'pending'
      return 'idle'
    },
    lotteryTitle() {
      const d = this.snap.lotteryDraft || {}
      return d.prizeName || d.title || this.miniTitle
    },
    lotteryWinnerCount() {
      const d = this.snap.lotteryDraft || {}
      if (Array.isArray(d.winners) && d.winners.length) return d.winners.length
      return d.winner ? 1 : 0
    },
    lotteryStatusText() {
      if (this.lotteryStatus === 'pending') return '抽奖中，请留意大屏'
      if (this.lotteryStatus === 'reveal') return '已揭晓，请查看大屏中奖名单'
      return '等待主持人开始抽奖'
    },
    messageCount() {
      const gd = this.gameData
      if (gd.messageCount != null) return Number(gd.messageCount) || 0
      return (gd.messages || []).length
    },
    /** 与活动配置的字数上限保持一致 */
    messageMaxLen() {
      const rule = (this.currentScene && this.currentScene.gameRule) || {}
      return Math.max(10, Number(rule.maxLength) || 30)
    },
    voteTotal() {
      if (!this.voteOptions.length) return 0
      return this.voteOptions.reduce((sum, opt) => sum + this.voteCount(opt), 0)
    },
    remainCount() {
      return Number(this.gameData.remainCount || 0)
    },
    grabbedCount() {
      const gd = this.gameData
      if (gd.grabbedCount != null) return Number(gd.grabbedCount) || 0
      return Math.max(0, Number(gd.totalCount || 0) - this.remainCount)
    },
    voteOptions() {
      const list = this.gameData.options
      return Array.isArray(list) && list.length ? list : ['支持', '反对', '弃权']
    },
    myVote() {
      const v = this.gameData.myVote
      if (v != null && v !== '') return String(v)
      return this.myVoteLocal
    },
    canPlay() {
      return this.joined && this.snap.phase === 'RUNNING'
    },
    countdownLeft() {
      const end = Number(this.snap.countdownEndAt || 0)
      if (!end || this.snap.phase !== 'COUNTDOWN') return 0
      return Math.max(0, Math.ceil((end - this.now) / 1000))
    },
    joinedCount() {
      if (this.snap.participantCount != null && this.snap.participantCount !== '') {
        return Number(this.snap.participantCount) || 0
      }
      return Number(this.snap.onlineCount) || 0
    },
    pageBgUrl() {
      const pick = scene => {
        const raw = scene && scene.mini && scene.mini.bg
        return raw ? String(raw).trim() : ''
      }
      let bg = pick(this.currentScene)
      if (!bg) {
        const home =
          this.scenes.find(s => s.sceneKey === 'home') ||
          this.scenes.find(s => s.mini && s.mini.bg) ||
          null
        bg = pick(home)
      }
      return bg ? getImageUrl(bg) : ''
    },
    /** 头像预览：已从相册选择则展示上传图，否则默认头像 */
    authAvatarPreview() {
      return this.avatarUrl || PARTY_DEFAULT_AVATAR
    }
  },
  mounted() {
    this.bootstrap()
  },
  beforeDestroy() {
    this.clearTimers()
    trackPartyPageLeave(this.pageStartedAt, { page: '/party/entry' })
    disposePartyTrack()
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  methods: {
    clearTimers() {
      if (this.pollTimer) clearInterval(this.pollTimer)
      if (this.reportTimer) clearInterval(this.reportTimer)
      if (this.tickTimer) clearInterval(this.tickTimer)
      this.pollTimer = null
      this.reportTimer = null
      this.tickTimer = null
    },
    onVisibilityChange() {
      if (document.hidden) {
        this.clearTimers()
      } else if (this.joined) {
        this.startLoops()
      }
    },
    unwrap(res) {
      if (!res) return null
      if (res.data != null && (res.status === 200 || res.success === true)) return res.data
      if (res.miniSceneKey || res.phase) return res
      return res.data || res
    },
    async bootstrap() {
      this.loading = true
      this.errorMsg = ''
      const query = mergeActivityEntryQuery(this.$route)
      this.activityCode = String(query.activity_code || query.activityCode || '').trim()
      this.storeCode = String(query.store_code || query.storeCode || '').trim()
      this.signParams = pickH5LinkSignParamsFromQuery(query)
      this.h5Uid = ensureSignstoreH5Uid(query.h5_uid)
      if (!this.activityCode) {
        this.loading = false
        this.errorMsg = '缺少活动编码'
        return
      }
      setPartyTrackContext({
        activityCode: this.activityCode,
        storeCode: this.storeCode,
        openid: this.h5Uid,
        source: query.source != null ? String(query.source) : (this.signParams.ts ? 'scan' : '')
      })
      initPartyTrack()
      trackPartyPageView('/party/entry', '互动活动用户入口')
      trackPartyEnter({ entry: 'h5' })

      try {
        await this.ensureLogin()
        const snap = await this.loadSnapshot()
        if (!snap || !(snap.miniSceneKey || snap.phase || snap.activityCode)) {
          throw new Error('活动不存在或链接已失效')
        }
        this.activityTitle = (snap.partyConfig && snap.partyConfig.theme && snap.partyConfig.theme.title) || '年会互动'
        this.applySnap(snap, true)
        // 已入场用户刷新后不再弹授权层：优先用服务端 joined 标记
        this.joined = !!snap.joined || Number(this.snap.myRank || 0) > 0
        if (this.joined) {
          this.startLoops()
        } else {
          // 本地已填过资料：静默入场，不再弹授权层（只需填一次）
          const saved = this.readSavedProfile()
          if (saved && this.isValidNick(saved.nickName) && this.isValidPhone(saved.phone)) {
            this.nickName = saved.nickName
            this.phone = saved.phone
            this.avatarUrl = saved.avatar || ''
            this.photoUrl = saved.photo || ''
            await this.doJoin(this.pickAvatar(), saved.nickName, saved.phone, { silent: true })
          }
          if (!this.joined) {
            this.trackMiniView('gate', '入场授权页')
            // 未入场直接弹仿微信授权层，不授权不能参与
            this.$nextTick(() => { this.authVisible = true })
          }
        }
      } catch (e) {
        this.errorMsg = (e && e.message) || '加载失败'
      } finally {
        this.loading = false
        document.addEventListener('visibilitychange', this.onVisibilityChange)
      }
    },
    async ensureLogin() {
      try {
        const auth = await ensureSignstoreAnonymousLoggedIn(this.h5Uid, h5AnonymousSilentLogin)
        if (auth && auth.h5Uid) this.h5Uid = auth.h5Uid
        setPartyTrackContext({ openid: this.h5Uid })
      } catch (e) {
        // 登录失败也允许看大屏快照（入场时再提示）
      }
    },
    async loadSnapshot() {
      if (this.signParams && this.signParams.ts && this.signParams.sign) {
        const res = await partyScreenBootstrap({
          activity_code: this.activityCode,
          store_code: this.storeCode || undefined,
          ts: this.signParams.ts,
          sign: this.signParams.sign
        })
        return this.unwrap(res)
      }
      const res = await partySnapshot({ activityCode: this.activityCode })
      return this.unwrap(res)
    },
    applySnap(data, first) {
      if (!data || typeof data !== 'object') return
      const prevPhase = this.snap.phase
      const rev = Number(data.rev || 0)
      if (!first && rev && rev === this.lastRev) {
        if (data.participantCount != null) this.$set(this.snap, 'participantCount', data.participantCount)
        if (data.onlineCount != null) this.$set(this.snap, 'onlineCount', data.onlineCount)
        if (data.gameData) { this.$set(this.snap, 'gameData', data.gameData); this.syncMyVote(data.gameData) }
        if (Array.isArray(data.photos)) this.$set(this.snap, 'photos', data.photos)
        if (data.myPhoto != null) this.$set(this.snap, 'myPhoto', data.myPhoto)
        if (data.lotteryDraft !== undefined) this.$set(this.snap, 'lotteryDraft', data.lotteryDraft)
        if (data.myScore != null) {
          const server = Number(data.myScore) || 0
          this.snap.myScore = this.snap.phase === 'RUNNING'
            ? Math.max(server, Number(this.snap.myScore) || 0)
            : server
        }
        if (data.myRank != null) this.snap.myRank = data.myRank
        return
      }
      this.lastRev = rev || this.lastRev
      // 换局/离开进行态时清掉上一局未上报的增量，避免带入新一局
      if (!first && prevPhase !== data.phase && data.phase !== 'RUNNING') this.pendingDelta = 0
      if (!first && this.snap.roundId && data.roundId && this.snap.roundId !== data.roundId) this.pendingDelta = 0
      const next = Object.assign({}, this.snap, data)
      if (data.partyConfig) next.partyConfig = data.partyConfig
      if (data.gameData) next.gameData = data.gameData
      // 同一局进行中服务端分数可能落后于本地点击，避免显示分数回跳
      if (next.myScore != null) {
        const server = Number(next.myScore) || 0
        const sameRound = (next.roundId || '') !== '' && (next.roundId || '') === (this.snap.roundId || '')
        next.myScore = (sameRound && next.phase !== 'SETTLED')
          ? Math.max(server, Number(this.snap.myScore) || 0)
          : server
      }
      this.snap = next
      this.syncMyVote(this.snap.gameData)
      if (prevPhase !== 'RUNNING' && next.phase === 'RUNNING') {
        trackPartyGameStart({ game_key: next.gameKey || '', scene: next.miniSceneKey || '' })
      }
      if (prevPhase === 'RUNNING' && next.phase === 'SETTLED') {
        trackPartyGameEnd({ game_key: next.gameKey || '', scene: next.miniSceneKey || '' })
      }
      this.$nextTick(() => {
        if (this.joined) this.trackMiniView(this.miniView, this.miniTitle)
      })
    },
    /** 新一轮投票开始时服务端 myVote 为空，清掉上一轮本地记录，避免显示已投 */
    syncMyVote(gameData) {
      if (!gameData || typeof gameData !== 'object' || !('myVote' in gameData)) return
      const serverVote = gameData.myVote
      if ((serverVote == null || serverVote === '') && this.myVoteLocal) {
        this.myVoteLocal = ''
      }
    },
    trackMiniView(view, label) {
      const v = view == null ? '' : String(view)
      if (!v || v === this.lastView) return
      this.lastView = v
      trackPartyMiniView(v, label)
    },
    startLoops() {
      this.clearTimers()
      this.pollTimer = setInterval(() => this.poll(), 1000)
      this.reportTimer = setInterval(() => this.flushScore(), 400)
      this.tickTimer = setInterval(() => {
        if (this.snap.phase !== 'COUNTDOWN') return
        this.now = Date.now()
      }, 200)
    },
    async poll() {
      if (this.polling) return
      this.polling = true
      try {
        const res = await partySnapshot({ activityCode: this.activityCode })
        this.applySnap(this.unwrap(res))
      } catch (e) {
        // ignore
      } finally {
        this.polling = false
      }
    },
    openAuth() {
      trackPartyUiClick('party_auth_open', '打开授权弹层')
      this.authVisible = true
    },
    onAuthDeny() {
      trackPartyUiClick('party_auth_deny', '拒绝授权')
      this.authVisible = false
      Toast('需授权后才能参与活动')
    },
    /** 点头像打开相册；再次点击可重新选择 */
    chooseAvatar() {
      if (this.avatarUploading) return
      trackPartyUiClick('party_avatar', '选择头像')
      const input = this.$refs.avatarInput
      if (input) input.click()
    },
    /** 相册选图：裁剪压缩后上传 OSS，拿文件名拼 images 裸链 */
    onAvatarChange(e) {
      const file = e && e.target && e.target.files && e.target.files[0]
      if (e && e.target) e.target.value = ''
      if (!file) return
      if (!/^image\//.test(file.type || '')) {
        Toast('请选择图片文件')
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        Toast('图片不能超过10MB')
        return
      }
      this.uploadAvatar(file)
    },
    compressAvatar(file, size = 320) {
      return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas')
            canvas.width = size
            canvas.height = size
            const ctx = canvas.getContext('2d')
            const side = Math.min(img.width, img.height)
            const sx = Math.max(0, (img.width - side) / 2)
            const sy = Math.max(0, (img.height - side) / 2)
            ctx.drawImage(img, sx, sy, side, side, 0, 0, size, size)
            canvas.toBlob(blob => {
              URL.revokeObjectURL(objectUrl)
              blob ? resolve(blob) : reject(new Error('图片处理失败'))
            }, 'image/jpeg', 0.85)
          } catch (err) {
            URL.revokeObjectURL(objectUrl)
            reject(err)
          }
        }
        img.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('图片读取失败'))
        }
        img.src = objectUrl
      })
    },
    async uploadAvatar(file) {
      this.avatarUploading = true
      try {
        const blob = await this.compressAvatar(file)
        const formData = new FormData()
        formData.append('file', blob, 'avatar.jpg')
        const res = await partyUploadImage(formData)
        const data = this.unwrap(res)
        const name = String((data && data.url) || '').trim()
        if (!name) throw new Error('上传失败')
        this.avatarUrl = resolveImageAssetUrl(name)
      } catch (err) {
        Toast((err && err.message) || '头像上传失败')
      } finally {
        this.avatarUploading = false
      }
    },
    /** 照片抽奖：点击居中照片框打开相册 */
    choosePhoto() {
      if (this.photoUploading) return
      trackPartyUiClick('party_photo', '上传抽奖照片')
      const input = this.$refs.photoInput
      if (input) input.click()
    },
    onPhotoChange(e) {
      const file = e && e.target && e.target.files && e.target.files[0]
      if (e && e.target) e.target.value = ''
      if (!file) return
      if (!/^image\//.test(file.type || '')) {
        Toast('请选择图片文件')
        return
      }
      if (file.size > 15 * 1024 * 1024) {
        Toast('图片不能超过15MB')
        return
      }
      this.uploadPhoto(file)
    },
    /** 上传抽奖照片：压缩后传 OSS，再写入房间玩家照片 */
    async uploadPhoto(file) {
      if (this.photoUploading) return
      this.photoUploading = true
      try {
        const blob = await this.compressAvatar(file, 720)
        const formData = new FormData()
        formData.append('file', blob, 'party-photo.jpg')
        const uploadRes = await partyUploadImage(formData)
        const data = this.unwrap(uploadRes)
        const name = String((data && data.url) || '').trim()
        if (!name) throw new Error('上传失败')
        const photo = resolveImageAssetUrl(name)
        const res = await partyUploadPhoto({
          activityCode: this.activityCode,
          photo
        })
        const snap = this.unwrap(res)
        if (snap) this.applySnap(snap, true)
        this.photoUrl = photo
        this.saveProfile({
          nickName: this.nickName,
          phone: this.phone,
          avatar: this.avatarUrl || '',
          photo
        })
        trackPartyInteract('photo', '上传抽奖照片')
        Toast('照片上传成功')
      } catch (err) {
        Toast((err && err.message) || '照片上传失败')
      } finally {
        this.photoUploading = false
      }
    },
    /** 头像选填：未选择时交给后端兜底默认头像 */
    pickAvatar() {
      return this.avatarUrl || ''
    },
    isValidNick(nick) {
      const n = String(nick || '').trim()
      if (!n) return false
      return !(n.indexOf('用户') === 0 || n === '微信用户' || n === '微信网友')
    },
    isValidPhone(phone) {
      return /^1[3-9]\d{9}$/.test(String(phone || '').trim())
    },
    async onAuthAllow() {
      trackPartyUiClick('party_auth_allow', '允许授权')
      const nick = String(this.nickName || '').trim()
      if (!this.isValidNick(nick)) {
        Toast('请填写有效昵称')
        return
      }
      const tel = String(this.phone || '').trim()
      if (!this.isValidPhone(tel)) {
        Toast('请填写正确的11位手机号')
        return
      }
      const avatar = this.pickAvatar()
      await this.doJoin(avatar, nick, tel)
    },
    async doJoin(avatar, nick, tel, opts) {
      const silent = !!(opts && opts.silent)
      if (this.joining || this.joined) return
      this.joining = true
      try {
        const res = await partyJoin({
          activityCode: this.activityCode,
          nickName: nick,
          phone: tel,
          avatar
        })
        const snap = this.unwrap(res)
        if (snap) this.applySnap(snap, true)
        this.joined = true
        this.authVisible = false
        this.startLoops()
        this.saveProfile({ nickName: nick, phone: tel, avatar: this.avatarUrl || '', photo: this.photoUrl || '' })
        trackPartyJoin({ nick: nick, platform: 'h5' })
        this.trackMiniView(this.miniView, this.miniTitle)
      } catch (e) {
        if (!silent) Toast((e && e.message) || '入场失败')
        else this.openAuth()
      } finally {
        this.joining = false
      }
    },
    /** 已填过的资料缓存：刷新/再次进入时静默入场，避免重复弹窗 */
    readSavedProfile() {
      try {
        const raw = window.localStorage.getItem('party_profile_' + this.activityCode)
        return raw ? JSON.parse(raw) : null
      } catch (e) {
        return null
      }
    },
    saveProfile(profile) {
      try {
        window.localStorage.setItem('party_profile_' + this.activityCode, JSON.stringify(profile || {}))
      } catch (e) {
        // ignore
      }
    },
    onTap() {
      if (!this.canPlay) return
      this.pendingDelta += 1
      this.snap.myScore = (this.snap.myScore || 0) + 1
    },
    async reportEvent(type, extra) {
      try {
        const res = await partyEvent(
          Object.assign(
            {
              activityCode: this.activityCode,
              type
            },
            extra || {}
          )
        )
        const snap = this.unwrap(res)
        if (snap) this.applySnap(snap)
        return true
      } catch (e) {
        Toast((e && e.message) || '操作失败')
        return false
      }
    },
    onSendMessage() {
      if (!this.canPlay) return
      const text = String(this.messageText || '').trim()
      if (!text) {
        Toast('请输入内容')
        return
      }
      this.messageText = ''
      trackPartyUiClick('party_message_send', '发送弹幕')
      trackPartyInteract('message', '弹幕')
      this.reportEvent('message', { text })
    },
    onLike() {
      if (!this.canPlay) return
      trackPartyUiClick('party_like', '点赞')
      trackPartyInteract('like', '点赞')
      this.reportEvent('like')
    },
    async onVote(option) {
      if (!this.canPlay || this.myVote) return
      const prev = this.myVoteLocal
      this.myVoteLocal = option
      trackPartyUiClick('party_vote', '投票', { target: option })
      trackPartyInteract('vote', '投票', { target: option })
      const ok = await this.reportEvent('vote', { target: option })
      if (!ok) this.myVoteLocal = prev
    },
    async onGrab() {
      if (!this.canPlay || this.grabBusy) return
      this.grabBusy = true
      trackPartyUiClick('party_grab', '抢红包')
      trackPartyInteract('grab', '抢红包')
      try {
        await this.reportEvent('grab')
      } finally {
        // 留出快照回填时间，避免连点重复请求
        setTimeout(() => { this.grabBusy = false }, 800)
      }
    },
    /** 单个选项票数（后端以选项文本为键，兼容历史按索引存的数据） */
    voteCount(option) {
      const votes = this.gameData.votes || {}
      const idx = this.voteOptions.indexOf(option)
      const val = votes[option] != null ? votes[option] : (votes[idx] != null ? votes[idx] : votes[String(idx)])
      return Number(val) || 0
    },
    votePercent(option) {
      if (!this.voteTotal) return 0
      return Math.round(this.voteCount(option) / this.voteTotal * 100)
    },
    async flushScore() {
      if (!this.joined || !this.pendingDelta || this.snap.phase !== 'RUNNING') return
      const delta = this.pendingDelta
      this.pendingDelta = 0
      try {
        const res = await partyScoreReport({
          activityCode: this.activityCode,
          delta,
          roundId: this.snap.roundId || undefined
        })
        this.applySnap(this.unwrap(res))
        trackPartyScore(delta, { round_id: this.snap.roundId || '' })
      } catch (e) {
        // 只在同一局内失败时补回分数，避免把上一局的增量带到下一局
        if (this.snap.phase === 'RUNNING') this.pendingDelta += delta
      }
    }
  }
}
</script>

<style scoped>
.party-entry {
  position: relative;
  min-height: 100vh;
  background: #0f172a;
  color: #f8fafc;
  overflow: hidden;
}
.party-entry.has-bg {
  background: #0a0614;
}
.party-entry__bg {
  position: fixed;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
  pointer-events: none;
}
.party-entry__body {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
}
.pe-state {
  padding: 120px 24px;
  text-align: center;
  color: #94a3b8;
}
.pe-state--err {
  color: #f87171;
}
.pe-gate {
  padding: 60px 12px 0;
  text-align: center;
}
.pe-gate__title {
  font-size: 22px;
  margin: 0 0 8px;
}
.pe-gate__sub {
  color: #94a3b8;
  font-size: 13px;
  margin: 0 0 24px;
}
.pe-gate__btn {
  border-radius: 10px;
}
.pe-main {
  padding-top: 8px;
}
.pe-hud {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 26px;
  margin-bottom: 24px;
}
.pe-hud__scene,
.pe-hud__phase {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 24px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.55);
  color: #f1f5f9;
  backdrop-filter: blur(8px);
}
.pe-hud__phase {
  color: #e2e8f0;
}
.pe-hud__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #94a3b8;
  transition: background 0.3s;
}
.pe-hud__phase.is-running {
  color: #bbf7d0;
}
.pe-hud__phase.is-running .pe-hud__dot {
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.18);
}
.pe-hud__phase.is-countdown {
  color: #fde68a;
}
.pe-hud__phase.is-countdown .pe-hud__dot {
  background: #f59e0b;
  animation: peDotPulse 1s ease-in-out infinite;
}
.pe-hud__phase.is-settled .pe-hud__dot {
  background: #a78bfa;
}
.pe-hud__phase.is-lottery {
  color: #fde68a;
}
.pe-hud__phase.is-lottery .pe-hud__dot {
  background: #fbbf24;
  animation: peDotPulse 1s ease-in-out infinite;
}
@keyframes peDotPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(0.7); }
}

/* 白卡：所有玩法的统一容器 */
.pe-card {
  padding: 44px 36px;
  border-radius: 40px;
  background: #fff;
  color: #0f172a;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
  text-align: center;
}
.pe-card__title {
  font-size: 38px;
  font-weight: 800;
  line-height: 1.35;
  margin: 0 0 16px;
}
.pe-card__sub {
  font-size: 26px;
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 32px;
}
.pe-card__tip {
  font-size: 24px;
  color: #94a3b8;
  line-height: 1.5;
  margin: 28px 0 0;
}
.pe-stats {
  display: flex;
  gap: 20px;
  margin: 32px 0 8px;
}
.pe-stat {
  flex: 1;
  padding: 24px 16px;
  border-radius: 28px;
  background: #f1f5f9;
}
.pe-stat span {
  display: block;
  font-size: 24px;
  color: #64748b;
}
.pe-stat strong {
  display: block;
  margin-top: 8px;
  font-size: 44px;
  font-weight: 800;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

/* 点击跑酷 */
.pe-tap__btn {
  display: block;
  width: 320px;
  height: 320px;
  margin: 40px auto 8px;
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 44px;
  font-weight: 800;
  letter-spacing: 2px;
  background: radial-gradient(circle at 35% 30%, #60a5fa 0%, #2563eb 55%, #1e40af 100%);
  box-shadow: 0 28px 60px rgba(37, 99, 235, 0.45);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  transition: transform 0.08s ease;
}
.pe-tap__btn:active:not(:disabled) {
  transform: scale(0.94);
}
.pe-tap__btn:disabled {
  opacity: 0.5;
  box-shadow: none;
}

/* 抽奖等待：三态状态胶囊 */
.pe-lottery {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 28px 0 8px;
  padding: 24px 32px;
  border-radius: 28px;
  font-size: 28px;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
}
.pe-lottery__dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: currentColor;
}
.pe-lottery.is-pending {
  color: #c2410c;
  background: linear-gradient(135deg, #fff7ed, #ffedd5);
}
.pe-lottery.is-pending .pe-lottery__dot {
  animation: peDotPulse 1s ease-in-out infinite;
}
.pe-lottery.is-reveal {
  color: #92400e;
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  box-shadow: inset 0 0 0 1px #fcd34d;
}

/* 消息上墙 */
.pe-message__input {
  margin-bottom: 24px;
  border-radius: 24px;
  background: #f8fafc;
}
.pe-message__actions {
  display: flex;
  gap: 20px;
}
/* 用 button 选择器而非 .van-button：避免命中 px→vw 的 van- 黑名单导致圆角不跟随缩放 */
.pe-message__actions button {
  border-radius: 24px;
}
.pe-like-btn {
  flex: 0 0 176px;
  border-radius: 24px;
}

/* 投票 */
.pe-vote__list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 8px;
}
.pe-vote__item {
  padding: 24px 28px;
  border-radius: 28px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, transform 0.12s;
}
.pe-vote__item:active {
  transform: scale(0.98);
}
.pe-vote__item.active {
  border-color: #2563eb;
  background: #eff6ff;
}
.pe-vote__item.disabled {
  opacity: 0.6;
}
.pe-vote__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.pe-vote__name {
  font-size: 30px;
  font-weight: 600;
  color: #0f172a;
}
.pe-vote__rate {
  font-size: 28px;
  font-weight: 800;
  color: #2563eb;
  font-variant-numeric: tabular-nums;
}
.pe-vote__bar {
  height: 12px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}
.pe-vote__fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #60a5fa, #2563eb);
  transition: width 0.35s ease;
}
.pe-vote__item.active .pe-vote__fill {
  background: linear-gradient(90deg, #fbbf24, #f59e0b);
}
.pe-vote__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 24px;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}
.pe-vote__mine {
  padding: 4px 16px;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-weight: 600;
}

/* 抢红包 */
.pe-grab {
  padding: 0;
  background: transparent;
  box-shadow: none;
}
.pe-grab__card {
  padding: 48px 36px;
  border-radius: 40px;
  color: #fff;
  background: radial-gradient(circle at 50% 0%, #f87171 0%, #dc2626 55%, #b91c1c 100%);
  box-shadow: 0 28px 68px rgba(185, 28, 28, 0.4);
}
.pe-grab__label {
  font-size: 28px;
  opacity: 0.9;
}
.pe-grab__amount {
  margin: 16px 0;
  font-size: 68px;
  font-weight: 800;
  letter-spacing: 2px;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}
.pe-grab__meta {
  font-size: 24px;
  opacity: 0.85;
}
.pe-grab__btn {
  width: 100%;
  height: 96px;
  margin-top: 36px;
  border: none;
  border-radius: 999px;
  background: #fde68a;
  color: #92400e;
  font-size: 34px;
  font-weight: 800;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.2);
  transition: transform 0.1s;
}
.pe-grab__btn:active:not(:disabled) {
  transform: scale(0.96);
}
.pe-grab__btn:disabled {
  opacity: 0.65;
}
.pe-grab .pe-card__tip {
  color: #e2e8f0;
}

/* 仿微信官方授权弹层 */
.pe-gate__tip {
  margin: 14px 0 0;
  font-size: 12px;
  color: #94a3b8;
}
.wx-auth-popup {
  background: #ededed;
}
.wx-auth {
  display: flex;
  flex-direction: column;
  background: #ededed;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  color: #191919;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', sans-serif;
}
/* 设计稿 750 宽：此处 px 会转成 vw，数值需按 2 倍设计稿书写 */
/* 头像置于活动名称位置：顶部居中，点击即可从相册重新选择 */
.wx-auth__avatar-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 40px 44px;
}
.wx-auth__avatar-wrap {
  position: relative;
}
.wx-auth__avatar-big {
  position: relative;
  width: 128px;
  height: 128px;
  border-radius: 50%;
  overflow: hidden;
  background: #dcdcdc;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.wx-auth__avatar-big img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.wx-auth__avatar-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 24px;
}
/* 「可选」贴在头像底部，不再单独占一行 */
.wx-auth__opt-tag {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
  padding: 2px 16px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 22px;
  line-height: 1.5;
  white-space: nowrap;
}
.wx-auth__file {
  display: none;
}
.wx-auth__list {
  background: #fff;
  margin: 0 32px;
  border-radius: 20px;
  overflow: hidden;
}
.wx-auth__item {
  display: flex;
  align-items: center;
  min-height: 100px;
  padding: 0 36px;
  border-bottom: 1px solid #f2f2f2;
}
.wx-auth__item:last-child {
  border-bottom: none;
}
.wx-auth__label {
  width: 168px;
  flex: 0 0 auto;
  font-size: 32px;
  color: #191919;
}
.wx-auth__req {
  color: #fa5151;
  font-style: normal;
  margin-right: 4px;
}
.wx-auth__input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  font-size: 32px;
  color: #191919;
  background: transparent;
  text-align: left;
}
.wx-auth__input::placeholder {
  color: #b2b2b2;
}
.wx-auth__tip {
  margin: 26px 0 0;
  padding: 0 44px;
  font-size: 26px;
  color: #888;
}
.wx-auth__actions {
  display: flex;
  margin-top: 26px;
  border-top: 1px solid #e5e5e5;
  background: #fff;
}
.wx-auth__btn {
  flex: 1;
  height: 104px;
  border: none;
  background: transparent;
  font-size: 34px;
  line-height: 104px;
  padding: 0;
}
.wx-auth__btn--deny {
  color: #191919;
  border-right: 1px solid #e5e5e5;
}
.wx-auth__btn--allow {
  color: #07c160;
  font-weight: 600;
}
.wx-auth__btn:disabled {
  opacity: 0.6;
}

/* 照片抽奖：居中上传/回显照片（设计稿 750，数值按 2 倍书写） */
.pe-photo {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  text-align: center;
}
.pe-photo__title {
  font-size: 40px;
  margin: 0 0 32px;
  font-weight: 700;
}
.pe-photo__frame {
  position: relative;
  width: 520px;
  height: 520px;
  border-radius: 32px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.35);
  cursor: pointer;
}
.pe-photo__frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.pe-photo__empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9aa3ad;
  font-size: 32px;
  letter-spacing: 2px;
}
.pe-photo__mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 32px;
}
.pe-photo__file {
  display: none;
}
.pe-photo__tip {
  margin: 32px 0 0;
  font-size: 26px;
  color: #cbd5e1;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}
</style>
